/**************************************************
 * Nombre:       Seccion_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {CASILLA_ESTADO, CASILLA_FECHA_DATOS} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Soporte from "../Dialogos/Dialogo_Soporte";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";


const Seccion_Soporte = () => {
    const cData = useContext(usuarioContext)
    const [wheres, setWheres] = useState([where('idUsuario', '==', 'none')]);
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025Wheres({coleccion: 'soportes', wheres: wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Soporte,
        titulo: 'Detalles del soporte',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }

    useEffect(() => {

        if (cData.usuario && cData.usuario.id) {

            let w = [where('idUsuario', '==', cData.usuario.id)]
            setWheres(w)

        }


    },[cData])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de peticiones de soporte'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Soporte

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Num y Titulo',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSUSUARIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]